<script>
export default {
    name: 'MessageContentQuickReply',
    props: {
        content: {
            type: Object
        },
        time: {
            type: String
        }
    }
}
</script>

<template>
<div class="d-flex flex-column">
  <div class="quick-reply-text">
    {{content.text}}
  </div>
  <div class="d-flex flex-column" style="gap: 8px">
    <span class="chat-time align-self-end">{{time | formatTimeHM}}</span>
    <div class="d-flex quick-reply-btns" style="gap: 8px">
      <button class="quick-reply-btn" v-for="(btn, idx) of content.buttons" :key="idx">
        {{btn.title}}
      </button>
    </div>
  </div>
</div>
</template>

<style scoped lang="scss">
.quick-reply-text {
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #D6D6D6;
  background: #E6E6E6;
}
.chat-time {
  color: #7B7B7B;
  font-size: 12px;
}
.quick-reply-btn {
  border-radius: 100px;
  border: 1px solid #EDEDED;
  padding: 0px 12px;
}
.quick-reply-btns {
  flex-wrap: wrap;
  justify-content: center;
}
</style>
